import { Button } from "@chakra-ui/react";
import { ArrowUpIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

export default function ReturnTopButton() {
  const navigate = useNavigate();
  const goToTopPage = () => {
    navigate("/"); // サイトのトップページに遷移
  };

  return (
    <Button
      leftIcon={<ArrowUpIcon />}
      colorScheme="teal"
      variant="solid"
      onClick={goToTopPage}
    >
      Return To Top Page
    </Button>
  );
}
